export const zh_TW = {
  'generator-title-apa6' : 'APA 第6版 參考文獻格式產生器 (免費)',
  'generator-title-apa7' : 'APA 第7版 參考文獻格式產生器 (免費)',
  'generator-title-mla7' : 'MLA 第7版 參考文獻格式產生器 (免費)',
  'generator-title-mla8' : 'MLA 第8版 參考文獻格式產生器 (免費)',
  'generator-title-chicago' : '芝加哥參考文獻格式產生器 (免費)',
  'generator-title-vancouver' : '溫哥華參考文獻格式產生器 (免費)',
  'generator-description-apa6' : '免費的APA第6版和第7版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！',
  'generator-description-apa7' : '免費的APA第6版和第7版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！',
  'generator-description-mla7' : '免費的MLA第7版和第8版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！',
  'generator-description-mla8' : '免費的MLA第7版和第8版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！',
  'generator-description-chicago' : '免費的芝加哥第17版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！',
  'generator-description-vancouver' : '免費產生溫哥華參考文獻引用格式，書籍、期刊文章和網頁。 書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！',
  'Brand Name' : 'Wordvice',
  'Citation Generator' : '參考文獻格式產生器',
  'Contributors': '貢獻者',
  'Page Name' : '網頁標題',
  'Site Name' : '網站名稱',
  'Date Published' : '出版日期',
  'Date Accessed' : '存取日期',
  'Publisher' : '出版社',
  'Publisher Name' : '出版社名稱',
  'Publication Info' : '出版訊息',
  'Publication Location' : '出版地點',
  'Publication Year' : '出版年份',
  'Day' : '日',
  'Month' : '月',
  'Year' : '年',
  'Generate' : '產生',
  'button_generate' : '產生',
  'Copied.' : '已複製',
  'copied_messgage' : '複製完成',
  'generate_result' : '產生结果',
  'Article Title' : '文章標題',
  'Journal Title' : '期刊名',
  'Edition' : '版號',
  'Volume' : '卷號',
  'Issue' : '期號',
  'Number' : '編號',
  'Pages' : '頁碼',
  'Website or Database Title' : '網站或資料庫名',
  'Title' : '標題',
  'Location' : '出版地點',
  'cite-Source' : '資料來源',
  'cite-Style' : '格式',
  'Copy' : '複製',
  'Delete' : '刪除',
  'Number or name' : '編號或名稱',
  'source-Website' : '網站',
  'source-Journal Article' : '期刊文章',
  'source-Book' : '書籍',
  'site_desc' : '選擇一種引用格式，輸入相關訊息後，即可自動參考文獻格式。',
  'Example' : '範例',
  'Format' : '格式',
  'Citation Style Guides' : '引用格式指南',
  'Author Last Name' : '姓氏',
  'Author First Name' : '名字',
  'Author First Initial' : '名字首字母',
  'Author Middle Name' : '中間名',
  'Author Middle Initial' : '中間名首字母',
  'Website Name' : '網站名稱',
  'Print' : '印刷版',
  'Digital' : '電子版',
  'Page Title' : '網頁標題',
  'Published Year' : '出版年份',
  'Published Date' : '出版日期',
  'citation-desc' : "選擇一種引用格式，輸入相關訊息，點擊 \"產生 \"按鈕，即可自動生成符合相關標準的參考文獻格式。所有生成結果將集中顯示在網頁中間位置\"Reference List\"中。您可直接複製貼上至參考文獻頁使用，也可隨時從列表中刪除不必要的項目。",
  'author' : '作者',
  'editor' : '編輯',
  'translator' : '譯者',
  'First Name' : '名字',
  'Middle' : '中間名',
  'Last Name' : '姓氏',
  'Quick Guides' : '引用格式指南',
  'APA Citation Guide' : 'APA格式引用指南',
  'MLA Citation Guide' : 'MLA格式引用指南',
  'Chicago Citation Guide' : 'Chicago格式引用指南',
  'Vancouver Citation Guide' : 'Vancouver格式引用指南',
  'Style Guide Introduction' : '參考文獻格式產生器',
  
  "apa" : {
    "page-title" : "APA參考文獻格式產生器(免費)",
    "page-description" : "選擇一種引用格式，輸入相關訊息，點擊 \"產生 \"，即可自動生成符合相關標準的參考文獻格式。所有生成結果將集中顯示在網頁中間位置\"Reference List\"中。您可直接複製貼上至參考文獻頁使用，也可隨時從列表中刪除不必要的項目。",
    "meta-title" : "APA參考文獻格式產生器(免費)",
    "meta-description" : "免費的APA第6版和第7版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！",
  },
  
  "mla" : {
    "page-title" : "MLA參考文獻格式產生器(免費)",
    "page-description" : "MLA 格式通常被作者和學生用於文化研究、英語、文學和批判理論等人文學科的手稿和研究論文。 Wordvice免費的MLA 參考文獻產生器能自動生成 MLA 第7版和 MLA第8版的參考文獻格式。查看MLA格式引用指南，了解更多MLA 內文引用(in-text citation)和參考文獻規則。",
    "meta-title" : "MLA參考文獻格式產生器(免費)",
    "meta-description" : "免費的MLA第7版和第8版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！",
  },
  
  "chicago" : {
    "page-title" : "芝加哥參考文獻格式產生器 (免費)",
    "page-description" : "芝加哥(Chicago)格式主要用於藝術、人文和社會科學領域的學術論文。Wordvice免費的芝加哥格式參考文獻產生器會自動生成芝加哥第17版參考文獻格式。查看芝加哥格式引文指南，了解更多芝加哥內文引用(in-text citation)和參考文獻規則。",
    "meta-title" : "芝加哥參考文獻格式產生器 (免費)",
    "meta-description" : "免費的芝加哥第17版參考文獻引用格式自動產生器。書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！",
  },
  
  "vancouver" : {
    "page-title" : "溫哥華參考文獻格式產生器 (免費)",
    "page-description" : "溫哥華(Vancouver)格式被數百種科學期刊使用，包括IEEE和MEDLINE。 在參考文獻方面，科學期刊有自己的作者指南。 溫哥華格式與其他幾種格式不同，它包含了任何作者-序號體系，但不規定格式的具體細節。查看溫哥華格式引用指南，了解具體的溫哥華引用規則。",
    "meta-title" : "溫哥華參考文獻格式產生器 (免費)",
    "meta-description" : "免費產生溫哥華參考文獻引用格式，書籍、期刊文章和網頁。 書籍、期刊文章和網站三種資料來源，複製自動產生正確格式的參考文獻，貼到參考文獻列表，方便快速且無廣告干擾！",
  },
  
  // sidebar
  "Citation Sources" : "Citation Sources",
  "citation_sources" : {
    "link1" : {
      "uri" : "https://blog.wordvice.com.tw/youtube-video-citation-apa-mla-chicago-vancouver/",
      "title" : "如何引用YouTube影片",
    },
    "link2" : {
      "uri" : "https://blog.wordvice.com.tw/how-to-cite-images-apa-mla-chicago-vancouver/",
      "title" : "如何引用圖片和數位影像",
    },
    "link3" : {
      "uri" : "https://blog.wordvice.com.tw/how-to-cite-movie-apa-mla-chicago-vancouver/",
      "title" : "如何引用電影",
    },
    "link4" : {
      "uri" : "https://blog.wordvice.com.tw/how-to-cite-a-website-apa-mla-chicago-vancouver/",
      "title" : "如何引用網站和網頁",
    },
    "link5" : {
      "uri" : "https://blog.wordvice.com.tw/how-to-cite-a-podcast-apa-mla-chicago-vancouver/",
      "title" : "如何引用Podcast",
    },
    "link6" : {
      "uri" : "https://blog.wordvice.com.tw/how-to-cite-chatgpt-sources-apa-mla-chicago-vancouver/",
      "title" : "如何引用ChatGPT",
    },
    "link7" : {
      "uri" : "https://blog.wordvice.com.tw/how-to-cite-a-book-apa-mla-chicago-vancouver-style/",
      "title" : "如何引用書籍",
    },
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh_TW.js